"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5967],{

/***/ 98992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _context_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40062);



function useModal() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ModalStateContext */ .s);
  if (!context) {
    throw new Error("useModal must be inside a ModalStateContext with a state value");
  }
  return context;
}




/***/ }),

/***/ 79096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ Slider; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(79215);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(9221);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(46626);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/autoplay/autoplay.js
var autoplay = __webpack_require__(13341);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/virtual/virtual.js
var virtual = __webpack_require__(55540);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Slider/helper.es.js
const renderPaginationStyle = (index, theme, paginationColor) => {
  const styleArr = [
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
      width: 24px;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #ddd;
      cursor: pointer;
      &:first-of-type {
        border-radius: 999px 0 0 999px;
      };
      &:last-of-type {
        border-radius: 0 999px 999px 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      position: relative;
      &:after {
        content: "";
        border-radius: 999px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${paginationColor};
      }
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transform: translateY(2px);
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};
const renderSwipeButton = (index) => {
  const styleArr = [
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-right: 0.5rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-left: 1rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};



// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(49713);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(18668);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-46f73e5ea2/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(17016);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Slider/Slider.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
core_class/* default.use */.Z.use([navigation/* default */.Z, pagination/* default */.Z, autoplay/* default */.Z, virtual/* default */.Z]);
const Slider = (_a) => {
  var _b = _a, {
    className,
    children,
    paginationStyle,
    navigationStyle,
    speed = 3e3,
    pauseOnMouseEnter = true,
    paginationColor,
    virtual = true
  } = _b, swiperProps = __objRest(_b, [
    "className",
    "children",
    "paginationStyle",
    "navigationStyle",
    "speed",
    "pauseOnMouseEnter",
    "paginationColor",
    "virtual"
  ]);
  const {
    slidesPerView,
    slidesPerGroup,
    slidesPerColumn,
    pagination,
    autoplay,
    loop
  } = swiperProps;
  const [swiperKey, setSwiperKey] = (0,react.useState)(0);
  const isMultipleRows = slidesPerColumn && slidesPerColumn > 1;
  if (pagination) {
    swiperProps.pagination = {
      clickable: true
    };
  }
  if (isMultipleRows)
    swiperProps.loop = false;
  if (autoplay) {
    swiperProps.autoplay = {
      delay: speed,
      disableOnInteraction: false,
      pauseOnMouseEnter
    };
  }
  if (!slidesPerGroup)
    swiperProps.slidesPerGroup = slidesPerView;
  (0,react.useEffect)(() => {
    setSwiperKey((key) => key + 1);
  }, [autoplay, loop, speed, pauseOnMouseEnter, virtual, slidesPerColumn]);
  return /* @__PURE__ */ react.createElement(Wrapper, {
    className,
    paginationStyle,
    navigationStyle,
    isMultipleRows,
    paginationColor
  }, /* @__PURE__ */ react.createElement(swiper/* Swiper */.t, __spreadProps(__spreadValues({
    key: `swiper-${swiperKey}`
  }, swiperProps), {
    slidesPerColumnFill: "row",
    resizeObserver: true,
    virtual: virtual ? {
      addSlidesBefore: slidesPerView
    } : false
  }), react.Children.map(children, (child, index) => /* @__PURE__ */ react.createElement(swiper_slide/* SwiperSlide */.o, {
    key: index,
    virtualIndex: index
  }, child))));
};
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(({
  isMultipleRows,
  paginationStyle,
  paginationColor,
  navigationStyle,
  theme
}) => `
    .swiper-container {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      padding: 0;
    }
    .swiper-wrapper {
      position: relative;
      height: 100%;
      display: flex;
      transition-property: transform;
      box-sizing: content-box;
      flex-wrap: ${isMultipleRows ? "wrap" : "nowrap"};
    }
    .swiper-slide {
      flex-shrink: 0;
      height: 100%;
      position: relative;
      transition-property: transform;
      ${isMultipleRows ? `margin-top: 0px !important` : ""};
    }
    &:hover {
      .swiper-button-next,
      .swiper-button-prev {
        opacity: 1;
        &.swiper-button-disabled {
          opacity: 0.35;
        }
      }
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-pagination-fraction {
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .swiper-pagination-bullets {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    ${renderPaginationStyle(paginationStyle, theme, paginationColor)};
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      top: 50%;
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      margin-top: -22px;
      opacity: 0;
      &.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
        pointer-events: auto;
      }
    }
    ${renderSwipeButton(navigationStyle)};
`);




/***/ }),

/***/ 49800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_COLOR_500 = {
  branding: "primary500",
  link: "link500",
  success: "success500",
  error: "error500",
  pending: "pending500"
};
const MAPPING_COLOR_600 = {
  branding: "primary600",
  link: "link600",
  success: "success600",
  error: "error600",
  pending: "pending600"
};
const MAPPING_COLOR_50 = {
  branding: "primary50",
  link: "link50",
  success: "success50",
  error: "error50",
  pending: "pending50"
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s4};
  padding-right: ${(p) => p.theme.spacing.s4};
  height: 1rem;
  border-radius: ${(p) => p.theme.borderRadius.s};
  border: ${(p) => p.borderColor ? `${p.theme.borderWeight.m} solid ${p.theme.colors[p.borderColor]}` : "unset"};
  background-color: ${(p) => p.theme.colors[p.backgroundColor]};
`;
const Tag = (_a) => {
  var _b = _a, {
    variant = "branding",
    type = "primary",
    content,
    className
  } = _b, rest = __objRest(_b, [
    "variant",
    "type",
    "content",
    "className"
  ]);
  const getBgColor = () => {
    if (type === "primary") {
      if (variant === "default")
        return "white";
      return MAPPING_COLOR_500[variant];
    }
    if (type === "secondary") {
      if (variant === "default")
        return "background";
      return MAPPING_COLOR_50[variant];
    }
    if (type === "ghost") {
      return "white";
    }
  };
  const getBorderColor = () => {
    if (type === "ghost") {
      if (variant === "default")
        return "border";
      return MAPPING_COLOR_600[variant];
    }
  };
  const getColor = () => {
    if (variant === "default")
      return "textPrimary";
    if (type === "primary")
      return "white";
    return MAPPING_COLOR_600[variant];
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    backgroundColor: getBgColor(),
    borderColor: getBorderColor(),
    className
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
    color: getColor(),
    level: 3,
    weight: "medium",
    line: 1
  }, content));
};




/***/ }),

/***/ 56927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ DeleteCircleFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const DeleteCircleFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM8.83979 8.64594C9.13268 8.35305 9.60755 8.35305 9.90045 8.64594L12.1371 10.8826L14.3738 8.64594C14.6667 8.35305 15.1416 8.35305 15.4345 8.64594C15.7274 8.93883 15.7274 9.41371 15.4345 9.7066L13.1978 11.9433L15.4343 14.1798C15.7272 14.4727 15.7272 14.9476 15.4343 15.2405C15.1414 15.5334 14.6666 15.5334 14.3737 15.2405L12.1371 13.004L9.90063 15.2405C9.60773 15.5334 9.13286 15.5334 8.83997 15.2405C8.54707 14.9476 8.54707 14.4727 8.83997 14.1798L11.0765 11.9433L8.83979 9.7066C8.54689 9.41371 8.54689 8.93883 8.83979 8.64594Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 63103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RightOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const RightOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 90450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);
/* harmony import */ var _Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6901);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  height: ${(props) => props.height + "px"};
  user-select: none;
`;
const StyledLogoLoading = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LogoLoading */ .h)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;
const PreLoad = (_a) => {
  var _b = _a, {
    height,
    isLoading,
    hideLogo = false,
    logo
  } = _b, props = __objRest(_b, [
    "height",
    "isLoading",
    "hideLogo",
    "logo"
  ]);
  if (!isLoading)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    height
  }), !hideLogo && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLogoLoading, {
    logo
  }));
};




/***/ }),

/***/ 67937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SelectOption; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73698);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBorderColor = (props) => {
  return props.isActive ? props.theme.brand.primary : "#e0e0e0";
};
const getColor = (props) => {
  return props.isActive ? props.theme.brand.primary : "#333333";
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: ${props.activeBackground && props.isActive ? props.activeBackground : "#fff"};
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.isDisabled ? "default" : "pointer"};
  ${props.block ? "width: 100%;" : ""}

  &:hover {
    background: ${props.isActive || props.isDisabled ? "" : "#f3f3f3"} ;
  }
  `);
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  color: ${props.activeBackground && props.isActive ? getColor(props) : ""};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.875rem;
 `);
const ActiveBorder = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  position: absolute;
  top: -1px;
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${props.stickySize === "sm" ? "0px 20px 20px 0px" : "0px 36px 36px 0px"};
  border-color: transparent ${props.theme.brand.primary} transparent transparent;
`);
const Checked = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span((props) => `
  position: absolute;
  top: ${props.stickySize === "sm" ? "-4px" : "0"};
  right: ${props.stickySize === "sm" ? "2px" : "6px"};
  color: #fff;
  z-index: 0;
  font-size: ${props.stickySize === "sm" ? "7px" : "10px"};
`);
const IconWrappper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  margin-left: 8px;
`;
const StyledTag = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tag */ .V)`
  margin-left: 8px;
`;
const SubTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .z.p`
  margin-bottom: 0.5rem;
  color: #848788;
`;
const Overlay = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #d8d8d852;
  z-index: 1;
`;
const SelectOption = (_a) => {
  var _b = _a, {
    title,
    subTitle,
    children,
    icon,
    tag,
    isActive,
    onClickOption,
    onClickIcon,
    onMouseEnter,
    activeBackground,
    stickySize,
    isDisabled,
    tags
  } = _b, props = __objRest(_b, [
    "title",
    "subTitle",
    "children",
    "icon",
    "tag",
    "isActive",
    "onClickOption",
    "onClickIcon",
    "onMouseEnter",
    "activeBackground",
    "stickySize",
    "isDisabled",
    "tags"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    activeBackground,
    isActive: !isDisabled && isActive,
    onClick: (ev) => !isDisabled && onClickOption(ev),
    onMouseEnter,
    isDisabled
  }, props), isDisabled && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Overlay, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    activeBackground,
    isActive: !isDisabled && isActive
  }, title, " ", tag && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({}, tag)), " ", (tags == null ? void 0 : tags.length) > 0 && tags.map((value) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({
    key: String(value.children)
  }, value))), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrappper, {
    onClick: onClickIcon
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l, __spreadValues({}, icon)))), subTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SubTitle, null, subTitle), children, !isDisabled && isActive && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActiveBorder, {
    stickySize
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Checked, {
    stickySize
  }, "\u2713")));
};




/***/ }),

/***/ 48579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OrderBy; },
/* harmony export */   "q": function() { return /* binding */ PromotionType; }
/* harmony export */ });
const PromotionType = {
  PRODUCT: "product",
  COUPON: "coupon"
};
var OrderBy = /* @__PURE__ */ ((OrderBy2) => {
  OrderBy2["ASC"] = "ASC";
  OrderBy2["DESC"] = "DESC";
  return OrderBy2;
})(OrderBy || {});




/***/ }),

/***/ 66349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63103);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68481);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69168);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const BlockHeader = ({
  title,
  titleColor,
  link,
  backgroundColor = "unset",
  tracking,
  className
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className,
    isMobile,
    backgroundColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title), link && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeeAll, __spreadValues({
    color: link.color
  }, tracking), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Xem t\u1EA5t c\u1EA3"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .RightOutlined */ .g, {
    color: link.color
  }))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({
  isMobile,
  theme,
  backgroundColor
}) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          ` : ""}
  height: ${isMobile ? "2.75rem" : "3.5rem"};
  background-color: ${backgroundColor};
`);
const SeeAll = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);




/***/ }),

/***/ 34469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ HorizontalSlider; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HorizontalSlider = (_a) => {
  var _b = _a, {
    slidesPerView,
    children
  } = _b, props = __objRest(_b, [
    "slidesPerView",
    "children"
  ]);
  if (!Array.isArray(children)) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), Array.isArray(children) && children.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    slidesPerView,
    key: index
  }, item)));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F, () => `
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  };
  transform: translate3d(0,0,0);
  `);
const Item = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
    width: ${100 / props.slidesPerView}%;
    flex-shrink: 0;
    margin-right: 8px;
  `);




/***/ }),

/***/ 26775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ProductCarousel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79096);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58735);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28247);
/* harmony import */ var _HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34469);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69168);
/* harmony import */ var _ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96790);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    products,
    productsPerRow,
    className,
    regionName,
    hideCtaButton
  } = _b, sliderSetting = __objRest(_b, [
    "products",
    "productsPerRow",
    "className",
    "regionName",
    "hideCtaButton"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const sliderConfig = __spreadValues(__spreadProps(__spreadValues({}, _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .defaultSlider */ .b), {
    spaceBetween: 12
  }), sliderSetting);
  if (isMobile) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "wrapper-horizontal-slider"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalSlider */ .r, {
      slidesPerView: productsPerRow || 2.3,
      className: "horizontal-slider"
    }, products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({
      key: index
    }, product), {
      tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O)({
        regionName,
        isTrackContent: true,
        contentName: product.sku,
        target: "productDetail"
      }) : {},
      addToCart: hideCtaButton ? null : product.addToCart
    })))));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSlider, __spreadProps(__spreadValues({}, sliderConfig), {
    slidesPerView: productsPerRow || 5,
    className
  }), products.map((item) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Card, {
    key: item.sku
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, item), {
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O)({
      regionName,
      isTrackContent: true,
      contentName: item.sku,
      target: "productDetail"
    }),
    addToCart: hideCtaButton ? null : item.addToCart
  })))));
};
const Card = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div`
  background: white;
  border-radius: 0.5rem;
`;
const StyledSlider = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Slider */ .i)`
  .swiper-slide {
    max-width: 230px;
  }
`;




/***/ }),

/***/ 41425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17016);
/* harmony import */ var _helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57732);




const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  discountPercent,
  textColor = "primary500",
  align = "start",
  size = "m",
  className,
  priceRange
}) => {
  const formattedRetailPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .x)(supplierRetailPrice);
  const formattedLatestPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .x)(latestPrice);
  let renderedRetailPrice, renderedDiscount;
  const renderedLatestPrice = () => {
    if (!priceRange) {
      return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
        level: 2,
        color: textColor,
        weight: "bold"
      }, formattedLatestPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
        level: 1,
        color: textColor
      }, formattedLatestPrice);
    }
    const formattedMinPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .x)(priceRange.min, false);
    const formattedMaxPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .x)(priceRange.max);
    return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTitle, {
      level: 2,
      color: textColor,
      weight: "bold",
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSubTitle, {
      level: 1,
      color: textColor,
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice);
  };
  switch (size) {
    case "l":
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: textColor
      }, discountPercent);
      break;
    default:
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: textColor
      }, discountPercent);
      break;
  }
  const isShowRetailPrice = supplierRetailPrice && supplierRetailPrice > latestPrice;
  const isShowDiscount = !!discountPercent;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductPriceWrapper, {
    align,
    className
  }, renderedLatestPrice(), (isShowRetailPrice || isShowDiscount) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiscount, null, isShowRetailPrice && renderedRetailPrice, isShowDiscount && renderedDiscount));
};
const ProductPriceWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
  height: 2.5rem;
`);
const StyledRetailPrice = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS)(({ theme }) => `
    text-decoration: line-through;
    margin-right: ${theme.spacing.s4};
`);
const StyledDiscount = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div`
  display: flex;
  height: 1rem;
`;
const StyledTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx)`
  word-break: break-all;
`;
const StyledSubTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK)`
  word-break: break-all;
`;




/***/ }),

/***/ 58735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ defaultSlider; }
/* harmony export */ });
const defaultSlider = {
  slidesPerView: 5,
  slidesPerColumn: 1,
  navigation: true,
  navigationStyle: 1,
  pagination: false,
  paginationStyle: 1,
  autoplay: false,
  loop: false,
  spaceBetween: 16
};




/***/ }),

/***/ 57732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
const formatCurrency = (value, includeUnit = true) => {
  if (typeof value !== "number")
    return null;
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  else
    currencyFormat = new Intl.NumberFormat("vi-VN");
  return currencyFormat.format(value);
};




/***/ }),

/***/ 68481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(96556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next/* default.t */.Z.t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 28858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GN": function() { return /* binding */ ContainerLoading; },
  "gb": function() { return /* binding */ Loading; },
  "b7": function() { return /* binding */ PreLoad; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(55271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/Common/PreLoad/PreLoad.es.js
var PreLoad_es = __webpack_require__(90450);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(55140);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(79185);
;// CONCATENATED MODULE: ./components/LogoLoading.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 80px;\n  height: 80px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



const Wrapper = styled_es/* styled.div */.z.div(_templateObject());
const Logo = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)(_templateObject1());
const Spinner = styled_es/* styled.div */.z.div((param)=>{
    let { theme  } = param;
    return "\n    background: none;\n    @keyframes ldio-yuapljtmof {\n      0% {\n        transform: rotate(0deg);\n      }\n      50% {\n        transform: rotate(180deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n    .ldio-yuapljtmof  {\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      margin: auto;\n      animation: ldio-yuapljtmof 1s linear infinite;\n      width: 70px;\n      height: 70px;\n      border-radius: 50%;\n      box-shadow: 0 2px 0 0 ".concat(theme.brand.loading || "#1435c3", ";\n      box-sizing: content-box;\n    }\n");
});
const LogoLoading = (_param)=>{
    var { logo =""  } = _param, props = _objectWithoutProperties(_param, [
        "logo"
    ]);
    const size = 80;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({}, props), {
        children: [
            logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                width: size / 2,
                height: size / 2,
                src: logo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ldio-yuapljtmof"
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Loading/Loading.es.js
var Loading_es = __webpack_require__(12433);
;// CONCATENATED MODULE: ./components/Loading.tsx
function Loading_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Loading_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Loading_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Loading_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Loading_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Loading_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Loading_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Loading_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Loading_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Loading_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Loading_templateObject() {
    const data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    Loading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Loading_templateObject1() {
    const data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n  transition: opacity 0.3s;\n  &.loading-blur {\n    clear: both;\n    overflow: hidden;\n    opacity: 0.5;\n    user-select: none;\n    pointer-events: none;\n  }\n"
    ]);
    Loading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = Loading_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  max-height: 400px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







const Loading = (param)=>{
    let { isLoading , children  } = param;
    const { logo  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
        isLoading: isLoading,
        logo: (logo.loading || logo.lite).path,
        children: children
    });
};
const PreLoad = (_param)=>{
    var { isLoading  } = _param, props = Loading_objectWithoutProperties(_param, [
        "isLoading"
    ]);
    var ref;
    const { logo  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreLoad_es/* PreLoad */.b, Loading_objectSpreadProps(Loading_objectSpread({}, props), {
        isLoading: isLoading,
        logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
    }));
};
const ContainerLoadingWrapper = styled_es/* styled.div */.z.div(Loading_templateObject());
const Container = styled_es/* styled.div */.z.div(Loading_templateObject1());
const LoadingContainer = styled_es/* styled.div */.z.div(_templateObject2());
const ContainerLoading = (param)=>{
    let { children , style , isLoading =true  } = param;
    var ref;
    const { logo  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerLoadingWrapper, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingContainer, {
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLoading, {
                    logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                className: isLoading ? "loading-blur" : "",
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 3119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useHomePage; },
/* harmony export */   "O": function() { return /* binding */ useMobileDefaultHomePage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89172);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62116);
/* harmony import */ var _useDiscovery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5899);




const useHomePage = (serverBlocks)=>{
    const { result: personalizedHomePage  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_1__/* .usePersonalizeBlocks */ .yz)({
        pageTypeEnum: _types__WEBPACK_IMPORTED_MODULE_2__/* .PageTypeEnum.HOME */ .DZ.HOME
    });
    const blocks = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (personalizedHomePage === null || personalizedHomePage === void 0 ? void 0 : personalizedHomePage.length) {
            return personalizedHomePage;
        }
        return serverBlocks;
    }, [
        personalizedHomePage
    ]);
    const slideBanners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const banner = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .findBlockByType */ .yA)("WIDE_THICK_BANNER", blocks);
        if (banner) {
            return (banner === null || banner === void 0 ? void 0 : banner.cookedData) || [];
        }
        return [];
    }, [
        blocks
    ]);
    const topRightBanners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const banner = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .findBlockByType */ .yA)("VERTICAL_2_BANNER", blocks);
        if (banner) {
            return (banner === null || banner === void 0 ? void 0 : banner.cookedData) || [];
        }
        return [];
    }, [
        blocks
    ]);
    const popupBanner = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .findBlockByType */ .yA)("POPUP_BANNER", blocks);
    }, [
        blocks
    ]);
    const horizontalFourBanners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var ref;
        return ((ref = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .findBlockByType */ .yA)("HORIZONTAL_4_BANNER", blocks)) === null || ref === void 0 ? void 0 : ref.cookedData) || [];
    }, [
        blocks
    ]);
    return {
        slideBanners,
        topRightBanners,
        blocks,
        popupBanner,
        horizontalFourBanners
    };
};
const useMobileDefaultHomePage = (serverBlocks)=>{
    const { result: personalizedHomePage , isLoading: loadingHomePage  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_1__/* .usePersonalizeBlocks */ .yz)({
        pageTypeEnum: _types__WEBPACK_IMPORTED_MODULE_2__/* .PageTypeEnum.HOME */ .DZ.HOME
    });
    const blocks = (personalizedHomePage === null || personalizedHomePage === void 0 ? void 0 : personalizedHomePage.length) ? personalizedHomePage : serverBlocks;
    const loading = !serverBlocks && loadingHomePage;
    return {
        blocks,
        loading
    };
};


/***/ }),

/***/ 29490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DefaultHome": function() { return /* binding */ DefaultHome; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ./components/desktop/organisms/DiscoveryBlocks.tsx
var DiscoveryBlocks = __webpack_require__(6796);
// EXTERNAL MODULE: ./components/desktop/organisms/RecentViewedProducts.tsx
var RecentViewedProducts = __webpack_require__(67600);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(55140);
// EXTERNAL MODULE: ./helpers/block.ts
var block = __webpack_require__(62116);
// EXTERNAL MODULE: ./hooks/useHomePage.tsx
var useHomePage = __webpack_require__(3119);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-2db71dd60f/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(89053);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(55271);
// EXTERNAL MODULE: ./hooks/banners.ts
var banners = __webpack_require__(28432);
;// CONCATENATED MODULE: ./modules/home/desktop/components/SideBanners.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 96px;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  min-width: 1264px;\n  z-index: -1;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 150px;\n  height: 350px;\n  z-index: 1040;\n  @media (max-width: 1600px) {\n    width: 60px;\n    height: 140px;\n  }\n  @media (max-width: 1366px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  object-fit: fill;\n  width: 100%;\n  transition: transform 0.4s;\n  &:hover {\n    transform: scale(1.05);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




const Parent = styled_es/* styled.div */.z.div(_templateObject());
const Wrapper = styled_es/* styled.div */.z.div(_templateObject1());
const Middle = styled_es/* styled.div */.z.div(_templateObject2());
const Banner = styled_es/* styled.div */.z.div(_templateObject3());
const StyledImg = styled_es/* styled.img */.z.img(_templateObject4());
const SideBanners = (param)=>{
    let { className  } = param;
    const { banners: responseRightBanners  } = (0,banners/* useBanners */.U)("right-sticky-banner-150x350");
    const { banners: responseLeftBanners  } = (0,banners/* useBanners */.U)("sticky-banner-150x350");
    const leftBanner = responseLeftBanners === null || responseLeftBanners === void 0 ? void 0 : responseLeftBanners[0];
    const rightBanner = responseRightBanners === null || responseRightBanners === void 0 ? void 0 : responseRightBanners[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Parent, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                    children: leftBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: leftBanner.targetPath,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImg, {
                            src: leftBanner.image
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Middle, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                    children: rightBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: rightBanner.targetPath,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImg, {
                            src: rightBanner.image
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./modules/home/desktop/components/AboveTheFold.tsx + 2 modules
var AboveTheFold = __webpack_require__(91973);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-46f73e5ea2/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(17016);
;// CONCATENATED MODULE: ./modules/home/desktop/DefaultHome.tsx
function DefaultHome_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DefaultHome_templateObject() {
    const data = DefaultHome_taggedTemplateLiteral([
        "\n  top: 8px;\n  > div {\n    margin-top: 88px;\n  }\n"
    ]);
    DefaultHome_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









const PopupPromotion = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2813).then(__webpack_require__.bind(__webpack_require__, 2813)).then((mod)=>mod.PopupPromotion), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2813)
            ]
    }
});
const QuestionnairesModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9151).then(__webpack_require__.bind(__webpack_require__, 89151)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(89151)
            ]
    }
});
const StyledSideBanners = (0,emotion_styled_browser_esm/* default */.Z)(SideBanners)(DefaultHome_templateObject());
const DefaultHome = (param)=>{
    let { serverBlocks , menuItems , mapProducts ={}  } = param;
    var ref;
    const { questionnairesUrl  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { slideBanners , topRightBanners , blocks , popupBanner , horizontalFourBanners ,  } = (0,useHomePage/* useHomePage */.J)(serverBlocks);
    const showPopupBanner = popupBanner && (popupBanner === null || popupBanner === void 0 ? void 0 : (ref = popupBanner.cookedData) === null || ref === void 0 ? void 0 : ref[0]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showPopupBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupPromotion, {
                banner: popupBanner.cookedData[0]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboveTheFold/* AboveTheFold */.J, {
                menuItems: (0,block/* findBlockByType */.yA)("MEGA_MENU", blocks) ? menuItems : [],
                slideBanners: slideBanners,
                topRightBanners: topRightBanners,
                horizontalFourBanners: horizontalFourBanners
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBanners, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoveryBlocks/* DiscoveryBlocks */.N, {
                blocks: blocks,
                mapProducts: mapProducts
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentViewedProducts/* RecentViewedProducts */.Z, {}),
            questionnairesUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionnairesModal, {})
        ]
    });
};


/***/ }),

/***/ 46586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ trackRemoveFromCart; },
/* harmony export */   "Kc": function() { return /* binding */ trackAddToCart; },
/* harmony export */   "_g": function() { return /* binding */ trackChangeQuantityProduct; },
/* harmony export */   "bz": function() { return /* binding */ trackSelectProduct; },
/* harmony export */   "gu": function() { return /* binding */ trackManually; },
/* harmony export */   "ih": function() { return /* binding */ trackDecreaseQuantityProduct; },
/* harmony export */   "lM": function() { return /* binding */ trackIncreaseQuantityProduct; },
/* harmony export */   "wr": function() { return /* binding */ trackAddToCartManually; }
/* harmony export */ });
/* harmony import */ var _interface_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41873);


const trackAddToCart = (product, selectedPromotionId, type, status, cartId) => {
  var _a;
  const { defaultPromotions = [] } = product;
  window.track(type ? type : _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART, {
    cartId,
    skuId: product.productInfo.sku,
    skuName: product.productInfo.name,
    promotionId: `${[
      ...defaultPromotions.map((promo) => promo.id),
      selectedPromotionId || ""
    ].join(",")}`,
    status: status || "success",
    quantity: 1,
    price: parseInt(product.prices[0].supplierRetailPrice),
    promotionPrice: product.addToCartPrice
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: product.productInfo.name,
            id: product.productInfo.sku,
            price: product.addToCartPrice,
            quantity: 1,
            category: ""
          }
        ]
      }
    }
  });
};
const trackIncreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a;
  window.track("increaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity + diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: diff,
            category: ""
          }
        ]
      }
    }
  });
};
const trackDecreaseQuantityProduct = (item, diff = 1, cartId) => {
  window.track("decreaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity - diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
};
const trackChangeQuantityProduct = (item, newQty, cartId) => {
  const currQty = item.quantity;
  if (currQty < newQty) {
    trackIncreaseQuantityProduct(item, newQty - currQty, cartId);
  } else if (currQty > newQty) {
    trackDecreaseQuantityProduct(item, currQty - newQty, cartId);
  }
};
const trackRemoveFromCart = (item, cartId) => {
  var _a;
  window.track("removeFromCart", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity,
    price: item.price,
    promotionPrice: item.sellPrice
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "removeFromCart",
    ecommerce: {
      remove: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: item.quantity,
            category: ""
          }
        ]
      }
    }
  });
};
const trackManually = (contentName, regionName, target, payload) => {
  window.track("manualTrackInteractionContent", {
    interaction: "click",
    contentName,
    regionName,
    target,
    payload
  });
};
const trackAddToCartManually = (trackingScreenName, sku) => {
  return trackManually("addToCart", "productCard", trackingScreenName, JSON.stringify({
    sku,
    screenName: trackingScreenName,
    index: 0
  }));
};
const trackSelectProduct = (item, checked, cartId) => {
  window.track(checked ? "selectProduct" : "unselectProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    price: item.sellPrice,
    promotionPrice: item.price,
    quantity: item.quantity,
    status: "success"
  });
};




/***/ }),

/***/ 41873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ AddToCartType; }
/* harmony export */ });
var AddToCartType = /* @__PURE__ */ ((AddToCartType2) => {
  AddToCartType2["ADDTOCART"] = "addToCart";
  AddToCartType2["BUYNOW"] = "buyNow";
  return AddToCartType2;
})(AddToCartType || {});




/***/ })

}]);